export default function formatTitle(text:any,limit:number){
    let textlength =text?.trim().length??0
    return textlength>limit?text:''
}